import { useState, useEffect } from "react"
import { Client } from "@planningcenter/api-client"

const client = new Client({
  app: "registrations",
  version: "2018-08-01"
})

const useFeature = (name, eventId) => {
  const [features, setFeatures] = useState()
  const [isLoading, setIsLoading] = useState(true)

  const fetchFeatures = async () => {
    setIsLoading(true)
    const response = await client.get({
      url: `/events/${eventId}/features`,
      data: {
        fields: {
          Feature: "name,state,enabled"
        }
      }
    })
    setFeatures(response.data)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchFeatures()
  }, [name])

  const feature = features?.find(feature => {
    return feature.name === name + "_" + window.railsEnv
  })

  const handleToggleFeature = async name => {
    const response = await client.post({
      url: `/events/${eventId}/toggle_feature`,
      data: {
        data: { attributes: { feature: name } }
      }
    })

    setFeatures(response.data)
  }

  return {
    toggle: handleToggleFeature,
    available: feature?.state == "available",
    enabled: feature?.enabled || false,
    isLoading
  }
}

export default useFeature
